import { ReactComponent as OutlineCalendarMonth } from "assets/svg/outline-calendar-month.svg";
import { ReactComponent as OutlineCalendar3Days } from "assets/svg/outline-calendar-3-days.svg";
import { ReactComponent as OutlineCalendarDay } from "assets/svg/outline-calendar-day.svg";
import {
  TIME_RANGE_TYPE,
  useCalendarTime,
} from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
import Section from "../section";
import getClasses from "utils/getClasses";
import styles from "./TimeRangeSection.module.scss";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { hideMobileSidebar } from "store/calendarSidebarSlice";
import messages from "messages";

const ICONS = {
  day: <OutlineCalendarDay />,
  threeDays: <OutlineCalendar3Days />,
  month: <OutlineCalendarMonth />,
};

const TimeRangeSection = () => {
  const dispatch = useDispatch();
  const { currentTimeRangeType, setCurrentTimeRangeType } = useCalendarTime();

  const switchRangeAndCloseSidebar = useCallback(
    (range: TIME_RANGE_TYPE) => {
      setCurrentTimeRangeType(range);
      dispatch(hideMobileSidebar());
    },
    [dispatch, setCurrentTimeRangeType],
  );

  return (
    <Section title="Views" isToggle defaultExpanded>
      {(["day", "threeDays", "month"] as TIME_RANGE_TYPE[]).map((range) => (
        <div
          key={range}
          className={getClasses(
            styles.option,
            currentTimeRangeType === range && styles.selected,
          )}
          onClick={() => switchRangeAndCloseSidebar(range)}
        >
          {ICONS[range]}
          {messages[range]}
        </div>
      ))}
    </Section>
  );
};

export default TimeRangeSection;
